import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Warehouse, Inbox } from "lucide-react";
import { BUSINESS, LEAD_SERVICES } from "@/data/content";

export const Footer = () => {
  return (
    <footer className="text-slate-300" style={{ backgroundColor: "var(--navy)" }} data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="mb-3 flex items-center gap-2">
              <Warehouse size={16} style={{ color: "var(--gold)" }} />
              <span className="text-xs font-bold tracking-widest" style={{ color: "var(--gold)" }}>
                REGINA'S GARAGE DOOR EXPERTS
              </span>
            </div>
            <h3 className="text-lg font-semibold text-white">{BUSINESS.name}</h3>
            <p className="mt-2 max-w-sm text-sm leading-relaxed text-slate-400">
              Residential and commercial garage door repair, installation, replacement, openers and
              maintenance in Regina and surrounding areas. Available 24/7.
            </p>
            <div className="mt-4 space-y-2 text-sm">
              <a href={BUSINESS.phoneHref} className="flex items-center gap-2 text-white hover:text-slate-200">
                <Phone size={16} className="text-blue-300" /> {BUSINESS.phone}
              </a>
              <a href={BUSINESS.emailHref} className="flex items-center gap-2 text-white hover:text-slate-200">
                <Mail size={16} className="text-blue-300" /> {BUSINESS.email}
              </a>
              <span className="flex items-center gap-2 text-white">
                <MapPin size={16} className="text-blue-300" /> {BUSINESS.area}
              </span>
            </div>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-white">Services</h4>
            <ul className="space-y-1.5">
              {LEAD_SERVICES.map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    data-testid={`footer-service-${s}`}
                    className="text-sm text-slate-400 transition-colors hover:text-white"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-white">Company</h4>
            <ul className="space-y-1.5 text-sm">
              <li><a href="#top" className="text-slate-400 hover:text-white">Home</a></li>
              <li><a href="#services" className="text-slate-400 hover:text-white">All services</a></li>
              <li><a href="#about" className="text-slate-400 hover:text-white">About us</a></li>
              <li><a href="#request" className="text-slate-400 hover:text-white">Request Service</a></li>
            </ul>
            <h4 className="mb-2 mt-5 text-sm font-semibold uppercase tracking-wider text-white">Hours</h4>
            <p className="text-sm text-slate-400">Available 24/7</p>
            <p className="text-sm text-slate-400">24/7 emergency garage door service</p>
          </div>
        </div>

        <div className="my-8 h-px bg-white/10" />

        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
          <div>
            <p className="text-xs text-slate-400">© {BUSINESS.name} · Regina & surrounding areas, SK</p>
            <p className="mt-1 text-[11px] text-slate-500">Commercial example photos: Wikimedia Commons, CC BY-SA 4.0</p>
          </div>
          <Link
            to="/staff"
            data-testid="staff-dispatch-link"
            className="flex items-center gap-1.5 text-xs text-slate-500 transition-colors hover:text-slate-300"
          >
            <Inbox size={13} /> Staff dispatch inbox
          </Link>
        </div>
      </div>
    </footer>
  );
};
